<template>
  <div class="list-items-about">
    <client-only>
      <div class="lg-block-hidden">
        <div class="list-items-about__content">
          <p v-html="about" />
        </div>
        <div v-if="showAction && !showFull">
          <div class="list-items-about__border" />
          <div class="list-items-about__bg" />
          <div class="list-items-about__btn">
            <BaseIcon
              name="arrow_drop_down"
              size="xl"
              class="cursor-pointer"
              @click="$emit('toggleHeight', true)"
            />
          </div>
        </div>
        <div v-if="showAction && showFull" class="text-center">
          <BaseIcon
            name="arrow_drop_up"
            size="xl"
            class="cursor-pointer"
            @click="$emit('toggleHeight', false)"
          />
        </div>
      </div>
    </client-only>
  </div>
</template>

<script>
import { shortenText } from '@helper/utils'

export default {
  name: 'TeacherListItemsAbout',
  inject: ['teacher'],
  props: {
    showFull: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    about () {
      return shortenText(this.teacher.about?.description, 800, true)
    },
    showAction () {
      return this.about && this.about.length > 650
    },
    link () {
      return this.$links.tutor_profile_link(this.$nuxt, this.teacher?.username)
    }
  }
}
</script>

<style scoped lang="scss">
.list-items-about {
  @apply relative;
  &__content {
    @apply text__body-3-md--regular text-body-2;
  }
  &__bg {
    @apply h-9 absolute inset-x-0 top-[296px] w-full bg-white z-10;
  }
  &__btn {
    @apply absolute mx-auto top-[287px] w-full z-30 text-center;
  }
  &__border {
    @apply h-16 absolute inset-x-0 top-[256px] w-full z-20;
    transition: all 0.2s ease-in-out;
    background: linear-gradient(180deg, hsl(0deg 0% 100% / 53%) 0%, #ffffff 100%);
  }
}
</style>
